import { Injectable } from '@angular/core';
import { InvestigationSavedFilterEntity } from '../../domain/entities/investigation-saved-filter.entity';
import { InvestigationSavedFilterResponseDto } from '../dtos/investigation-saved-filter-response.dto';

@Injectable({ providedIn: 'root' })
export class InvestigationPredefinedFiltersMapper {
  public toDomain(dto: InvestigationSavedFilterResponseDto): InvestigationSavedFilterEntity {
    const entity = new InvestigationSavedFilterEntity();
    entity.id = dto.id;
    entity.name = dto.name;
    entity.description = dto.description ?? null;
    entity.filter = dto.filter;
    entity.isSystem = dto.isSystem;
    entity.isActive = dto.isActive;
    entity.displayOrder = dto.displayOrder;
    entity.count = dto.count;
    return entity;
  }

  public toDomainArray(dtos: InvestigationSavedFilterResponseDto[]): InvestigationSavedFilterEntity[] {
    return dtos.map((dto) => this.toDomain(dto));
  }
}
